<template>
  <div class="pb-3" >
    <va-card :title="$t(`promotions.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="promotion.name"
                  :label="$t('promotions.forms.nameLabel')"
                  :placeholder="$t('promotions.forms.namePlaceholder')"
                  :success="errors.length == 0 && promotion.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Data Inicio" v-slot="{ errors }">
                <va-date-picker
                  :label="$t('promotions.forms.dateInitialLabel')"
                  :placeholder="$t('promotions.forms.dateInitialPlaceholder')"
                  :config="{enableTime: false, dateFormat: 'Y-m-d'}"
                  :success="errors.length == 0"
                  :error="errors.length > 0"
                  :messages="errors"
                  v-model="promotion.dateInitial"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Data Termino" v-slot="{ errors }">
                <va-date-picker
                  :label="$t('promotions.forms.dateFinalLabel')"
                  :placeholder="$t('promotions.forms.dateFinalPlaceholder')"
                  :config="{enableTime: false, dateFormat: 'Y-m-d'}"
                  :success="errors.length == 0"
                  :error="errors.length > 0"
                  :messages="errors"
                  v-model="promotion.dateFinal"
                />
              </ValidationProvider>
              <div v-if='oldFile.length > 0' class="form-group mt-3">
                <img
                  :src="$store.getters['environment/cdn'] + '/promotions/' + oldFile"
                  style="height: 30vh; max-width: 100%;"
                >
              </div>
              <ValidationProvider name="Imagem" :rules="oldFile.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('promotions.forms.fileLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="file"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <label>{{$t('promotions.forms.activePlaceholder')}}</label>
              <va-toggle
                v-model="promotion.active"
                small
                :label="promotion.active ? 'Ativado' : 'Desativado'"
              />
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import ErrorMessages from '../utils/ErrorMessages'

import gql from 'graphql-tag'
export default {
  name: 'PromotionAddUpdate',
  components: { ErrorMessages },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      promotion: {
        name: '',
        file: '',
        dateInitial: '',
        dateFinal: '',
        active: false,
      },
      oldFile: '',
      file: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.promotion.name = ''
    this.promotion.file = ''
    this.promotion.dateInitial = ''
    this.promotion.dateFinal = ''
    this.promotion.active = false
    if (this.updateData !== null) {
      this.promotion_get(this.updateData)
    }
  },
  watch: {
    file (value) {
      if (value.length > 0) {
        this.promotion.file = value[0].name
      }
    },
    updateData (value) {
      if (this.updateData !== null) {
        this.promotion_get(this.updateData)
      } else {
        this.promotion.name = ''
        this.promotion.file = ''
        this.promotion.dateInitial = ''
        this.promotion.dateFinal = ''
        this.promotion.active = false
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    promotion_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'file') {
            this.oldFile = data[value]
            this.file[value] = ''
          } else if (value === 'date_initial') {
            this.promotion.dateInitial = data[value]
          } else if (value === 'date_final') {
            this.promotion.dateFinal = data[value]
          } else {
            this.promotion[value] = data[value]
          }
        }
      })
    },
    upload () {
      if (this.promotion.file.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.file[0])
        formData.append('path', 'promotions')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldFile)
        }
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.promotion.file = resp.data.filename
          this.onSubmit()
        })
      } else {
        this.promotion.file = this.oldFile
        this.onSubmit()
      }
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, file, dateInitial, dateFinal, active } = this.promotion
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation  MyMutation($name: String!, $file: String!, $date_initial: date!, $date_final: date!, $active: Boolean!, $id: Int!) {
                  update_promotion_by_pk(pk_columns: {id: $id}, _set: {name: $name, file: $file, date_initial: $date_initial, date_final: $date_final, active: $active}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($name: String!, $file: String!, $date_initial: date!, $date_final: date!, $active: Boolean!) {
                  insert_promotion(objects: {name: $name, file: $file, date_initial: $date_initial, date_final: $date_final, active: $active}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            name,
            file,
            date_initial: dateInitial,
            date_final: dateFinal,
            active,
            id: this.promotion.id,
          } : {
            name,
            file,
            date_initial: dateInitial,
            date_final: dateFinal,
            active,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.promotion.name = ''
          self.promotion.file = ''
          self.promotion.dateInitial = ''
          self.promotion.dateFinal = ''
          self.promotion.active = false
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.promotion.name = ''
          self.promotion.file = ''
          self.promotion.dateInitial = ''
          self.promotion.dateFinal = ''
          self.promotion.active = false
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
